/**
 * House of Chic - Pop-Up Shop Form Handler & Google Sheets Integration
 */
(function () {
  "use strict";

  console.log("🚀 House of Chic Pop-Up Shop script initializing...");

  // =========================================================
  // UTM PARAMETERS EXTRACTION
  // =========================================================
  const params = new URLSearchParams(window.location.search);
  const utmFields = {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_term: params.get("utm_term") || "",
    utm_content: params.get("utm_content") || ""
  };

  // =========================================================
  // FORM HANDLER INITIALIZATION
  // =========================================================
  function initHouseOfChicForm() {
    const form = document.getElementById("houseOfChicForm");
    if (!form) return;

    const nameInput = document.getElementById("hoc_full_name");
    const emailInput = document.getElementById("hoc_email");
    const countryCodeSelect = document.getElementById("hoc_country_code");
    const phoneInput = document.getElementById("hoc_phone_number");
    const locationSelect = document.getElementById("hoc_popup_location");

    const friend1CountrySelect = document.getElementById("hoc_friend1_country_code");
    const friend1PhoneInput = document.getElementById("hoc_friend1_phone");

    const friend2CountrySelect = document.getElementById("hoc_friend2_country_code");
    const friend2PhoneInput = document.getElementById("hoc_friend2_phone");

    const submitBtn = document.getElementById("hoc_submit_btn");
    const btnText = submitBtn?.querySelector(".hoc-btn-text");
    const btnLoader = submitBtn?.querySelector(".hoc-btn-loader");
    const errorBanner = document.getElementById("hoc_form_error_msg");
    const successBox = document.getElementById("hoc_success_box");
    const resetBtn = document.getElementById("hoc_reset_btn");

    // Email validation helper
    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    // Phone validation helper
    function isValidPhone(phone) {
      const cleaned = phone.replace(/[^0-9]/g, "");
      return cleaned.length >= 7 && cleaned.length <= 15;
    }

    // Real-time button activation check (Mandatory fields: Name, Email, Phone, Location)
    function checkFormValidity() {
      const fullNameVal = nameInput ? nameInput.value.trim() : "";
      const emailVal = emailInput ? emailInput.value.trim() : "";
      const phoneVal = phoneInput ? phoneInput.value.trim() : "";
      const locationVal = locationSelect ? locationSelect.value.trim() : "";

      const isNameValid = fullNameVal.length >= 2;
      const isEmailValid = isValidEmail(emailVal);
      const isPhoneValid = isValidPhone(phoneVal);
      const isLocationValid = locationVal !== "";

      const allMandatoryFilled = isNameValid && isEmailValid && isPhoneValid && isLocationValid;

      if (submitBtn) {
        if (allMandatoryFilled) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute("aria-disabled");
          submitBtn.classList.add("is-active");
        } else {
          submitBtn.disabled = true;
          submitBtn.setAttribute("aria-disabled", "true");
          submitBtn.classList.remove("is-active");
        }
      }

      return allMandatoryFilled;
    }

    // Clear individual error
    function clearError(inputEl, errorElId) {
      if (inputEl) inputEl.classList.remove("is-invalid");
      const errEl = document.getElementById(errorElId);
      if (errEl) {
        errEl.textContent = "";
        errEl.style.display = "none";
      }
    }

    // Set individual error
    function setError(inputEl, errorElId, message) {
      if (inputEl) inputEl.classList.add("is-invalid");
      const errEl = document.getElementById(errorElId);
      if (errEl) {
        errEl.textContent = message;
        errEl.style.display = "block";
      }
    }

    // Listen to changes to toggle submit button and clear errors
    [nameInput, emailInput, phoneInput, locationSelect].forEach(function (el) {
      if (!el) return;
      el.addEventListener("input", function () {
        clearError(el, "error_" + el.name);
        if (errorBanner) errorBanner.style.display = "none";
        checkFormValidity();
      });
      el.addEventListener("change", function () {
        clearError(el, "error_" + el.name);
        checkFormValidity();
      });
      el.addEventListener("blur", function () {
        checkFormValidity();
      });
    });

    // Sanitize phone inputs to numbers only
    [phoneInput, friend1PhoneInput, friend2PhoneInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9]/g, "");
        checkFormValidity();
      });
    });

    // Initial check on load
    checkFormValidity();

    // Form Submission Handler
    async function handleFormSubmit(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const fullNameVal = nameInput ? nameInput.value.trim() : "";
      const emailVal = emailInput ? emailInput.value.trim() : "";
      const phoneVal = phoneInput ? phoneInput.value.trim() : "";
      const locationVal = locationSelect ? locationSelect.value.trim() : "";

      let isValid = true;

      // 1. Validate Full Name
      if (!fullNameVal || fullNameVal.length < 2) {
        setError(nameInput, "error_full_name", "Please enter your full name");
        isValid = false;
      } else {
        clearError(nameInput, "error_full_name");
      }

      // 2. Validate Email
      if (!emailVal || !isValidEmail(emailVal)) {
        setError(emailInput, "error_email", "Please enter a valid email address");
        isValid = false;
      } else {
        clearError(emailInput, "error_email");
      }

      // 3. Validate Phone Number
      if (!phoneVal || !isValidPhone(phoneVal)) {
        setError(phoneInput, "error_phone_number", "Please enter a valid phone number");
        isValid = false;
      } else {
        clearError(phoneInput, "error_phone_number");
      }

      // 4. Validate Location
      if (!locationVal) {
        setError(locationSelect, "error_popup_location", "Please select a pop-up location");
        isValid = false;
      } else {
        clearError(locationSelect, "error_popup_location");
      }

      // 5. Optional Friends Phone validation
      const friend1PhoneVal = friend1PhoneInput ? friend1PhoneInput.value.trim() : "";
      if (friend1PhoneVal && !isValidPhone(friend1PhoneVal)) {
        setError(friend1PhoneInput, "error_phone_number", "Please enter a valid phone number for friend 1");
        isValid = false;
      }

      const friend2PhoneVal = friend2PhoneInput ? friend2PhoneInput.value.trim() : "";
      if (friend2PhoneVal && !isValidPhone(friend2PhoneVal)) {
        setError(friend2PhoneInput, "error_phone_number", "Please enter a valid phone number for friend 2");
        isValid = false;
      }

      if (!isValid) {
        checkFormValidity();
        const firstInvalid = form.querySelector(".is-invalid");
        if (firstInvalid) {
          firstInvalid.focus();
        }
        return false;
      }

      // Set Loading State
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute("aria-disabled", "true");
      }
      if (btnText) btnText.style.display = "none";
      if (btnLoader) btnLoader.style.display = "inline-flex";
      if (errorBanner) errorBanner.style.display = "none";

      const countryCodeVal = countryCodeSelect ? countryCodeSelect.value : "+1";
      const friend1CountryVal = friend1CountrySelect ? friend1CountrySelect.value : "+1";
      const friend2CountryVal = friend2CountrySelect ? friend2CountrySelect.value : "+1";

      const formDataPayload = {
        timestamp: new Date().toISOString(),
        submission_date: new Date().toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }),
        submission_time: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" }),
        full_name: fullNameVal,
        email: emailVal,
        country_code: countryCodeVal,
        phone_number: phoneVal,
        full_phone: countryCodeVal + " " + phoneVal,
        popup_location: locationVal,
        friend1_country_code: friend1PhoneVal ? friend1CountryVal : "",
        friend1_phone: friend1PhoneVal,
        friend1_full_phone: friend1PhoneVal ? friend1CountryVal + " " + friend1PhoneVal : "",
        friend2_country_code: friend2PhoneVal ? friend2CountryVal : "",
        friend2_phone: friend2PhoneVal,
        friend2_full_phone: friend2PhoneVal ? friend2CountryVal + " " + friend2PhoneVal : "",
        utm_source: utmFields.utm_source,
        utm_medium: utmFields.utm_medium,
        utm_campaign: utmFields.utm_campaign,
        utm_term: utmFields.utm_term,
        utm_content: utmFields.utm_content,
        page_url: window.location.href,
        form_name: "house_of_chic_form"
      };

      const scriptURL = form.getAttribute("data-script-url") || "https://script.google.com/macros/s/AKfycbzRBVQ64skOmKdpuAxhX9ou8knbVQG40sqvXXkBQrUIVk9H8p_HQFkzEwzELuGUZVs8EA/exec";

      console.log("📤 Submitting RSVP to Google Sheets:", formDataPayload);

      // 1. Send data to Google Apps Script asynchronously (non-blocking)
      try {
        fetch(scriptURL, {
          method: "POST",
          mode: "no-cors",
          keepalive: true,
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formDataPayload)
        }).catch(function (err) {
          console.warn("Background fetch notice:", err);
        });
      } catch (err) {
        console.warn("Fetch initiate error:", err);
      }

      // 2. Exact DataLayer Push (Instant)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "house_of_chic_form_submit",
        form_name: "house_of_chic_form",
        campaign_name: "house_of_chic",
        lead_type: "store_popup_lead",
        submission_method: "website_form",
        popup_location: locationVal || "",
        page_url: window.location.href
      });

      console.log("📊 dataLayer pushed successfully:", window.dataLayer[window.dataLayer.length - 1]);

      // 3. WebEngage Tracking (Instant)
      if (window.webengage && typeof window.webengage.track === "function") {
        try {
          window.webengage.track("house_of_chic_form_submit", {
            form_name: "house_of_chic_form",
            popup_location: locationVal,
            full_name: fullNameVal,
            email: emailVal,
            phone_number: countryCodeVal + " " + phoneVal
          });
          if (window.webengage.user && typeof window.webengage.user.setAttribute === "function") {
            window.webengage.user.setAttribute("full_name", fullNameVal);
            window.webengage.user.setAttribute("email", emailVal);
            window.webengage.user.setAttribute("phone", countryCodeVal + " " + phoneVal);
          }
        } catch (weErr) {
          console.warn("WebEngage tracking error:", weErr);
        }
      }

      // 4. Fast transition to Success Screen (400ms for smooth user experience)
      setTimeout(function () {
        if (btnText) btnText.style.display = "inline";
        if (btnLoader) btnLoader.style.display = "none";
        form.style.display = "none";
        if (successBox) {
          successBox.style.display = "block";
        }
      }, 400);

      return false;
    }

    // Attach submit events
    form.addEventListener("submit", handleFormSubmit);

    // Reset Form for another registration
    if (resetBtn) {
      resetBtn.addEventListener("click", function (e) {
        e.preventDefault();
        form.reset();
        clearError(nameInput, "error_full_name");
        clearError(emailInput, "error_email");
        clearError(phoneInput, "error_phone_number");
        clearError(locationSelect, "error_popup_location");
        if (errorBanner) errorBanner.style.display = "none";
        if (successBox) successBox.style.display = "none";
        form.style.display = "flex";
        checkFormValidity();
      });
    }
  }

  // =========================================================
  // UNLOCK / SCROLL BUTTON LISTENER
  // =========================================================
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".unlock-btn");
    if (!btn) return;
    const target = document.getElementById("form-box-id");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  // =========================================================
  // INITIALIZE ON DOM READY
  // =========================================================
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHouseOfChicForm);
  } else {
    initHouseOfChicForm();
  }
})();

